import * as React from 'react';
import { observer } from 'mobx-react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import AuthenticationMethod from 'owa-service/lib/contract/AuthenticationMethod';
import IMAPSecurityMechanism from 'owa-service/lib/contract/IMAPSecurityMechanism';
import { getAuthenticationOptions } from '../selectors/getAuthenticationOptions';
import { getSecurityOptions } from '../selectors/getSecurityOptions';
import { ConnectionType } from '../store/schema/ConnectionType';
import strings from 'owa-strings/owa-options-strings';

const styles = require('./BasicAuthenticationOptions.scss');

export interface BasicAuthenticationOptionsProps {
    connectionType: ConnectionType;
    incomingAuth: AuthenticationMethod;
    incomingSecurity: IMAPSecurityMechanism;
    onUpdateIncomingAuth: (value: AuthenticationMethod) => void;
    onUpdateIncomingSecurity: (value: IMAPSecurityMechanism) => void;
}

@observer
export default class BasicAuthenticationOptions extends React.Component<
    BasicAuthenticationOptionsProps,
    {}
> {
    private onIncomingAuthChanged = (option: IDropdownOption, index?: number) => {
        this.props.onUpdateIncomingAuth(option.key as AuthenticationMethod);
    };

    private onIncomingSecurityChanged = (option: IDropdownOption, index?: number) => {
        this.props.onUpdateIncomingSecurity(option.key as IMAPSecurityMechanism);
    };

    render() {
        return (
            <div>
                <Dropdown
                    className={styles.dropdown}
                    label={strings.options_connected_advanced_authenticationDropdown}
                    onChanged={this.onIncomingAuthChanged}
                    options={getAuthenticationOptions(this.props.connectionType)}
                    selectedKey={this.props.incomingAuth}
                />
                <Dropdown
                    className={styles.dropdown}
                    label={strings.options_connected_advanced_encryptionDropdown}
                    onChanged={this.onIncomingSecurityChanged}
                    options={getSecurityOptions()}
                    selectedKey={this.props.incomingSecurity}
                />
            </div>
        );
    }
}
